import { Component, DestroyRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { VehicleTypeDetail } from '@core/models/vehicle-type-detail.model';
import { ADD_SPOT_LABEL, EQUIPMENT_INFORMATION_LABEL, MSG_DELETE_ACCOUNT, MSG_DELETE_EQUIPMENT, NO_IMAGE, RESET_PASSWORD_CONFIRMATION, SPOT_TYPE_LABEL, USER_ROLES, USER_TYPE } from '@shared/constant/shared.constant';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { CommonFunctions } from '@shared/common-functions';
import { CompanyService, BreadcrumbItem } from '@shared/services/company.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { ToastService } from '@shared/services/toast.service';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { ConfirmationService } from 'primeng/api';
import { SuperAdminService } from '@core/services/super-admin.service';
import { CancelBookingComponent } from '../booking-flow/cancel-booking/cancel-booking.component';
import { BookingInvoiceComponent } from '../booking-invoice/booking-invoice.component';
import { DeleteConfirmationModalComponent } from '../delete-confirmation-modal/delete-confirmation-modal.component';
import { AddNotesComponent } from '../driver/add-notes/add-notes.component';
import { DriverService } from '../driver/services/driver.service';
import { DriverService as SharedDriverService } from '@core/services/driver.service';
import { ParkingService } from '../parking-lot/services/parking.service';
import { ResetPasswordConfirmationComponent } from '../reset-password-confirmation/reset-password-confirmation.component';
import { VehicleTypeModalComponent } from '../vehicle-type-modal/vehicle-type-modal.component';
import { DriverNotesHistory, FilterData } from '@core/models/api-response.model';
import { InvoiceType } from '../custom-invoice/custom-invoice.component';
import { ReloadService } from '@shared/services/reload.service';
import { GroupBookingInvoiceComponent } from '../group-user-booking/group-booking-invoice/group-booking-invoice.component';
import { UserCrmFilterModalComponent } from './user-crm-filter-modal/user-crm-filter-modal.component';
import { DatePipe } from '@angular/common';
import { CustomCreditsComponent } from '../custom-credits/custom-credits.component';
import { UserConvertToGroupOperatorModalComponent } from '../user-convert-to-group-operator-modal/user-convert-to-group-operator-modal.component';
import { BookingType } from '@core/models/booking.model';
import { ProfileService } from '@core/services/profile.service';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

interface YearOption {
  key: number;
  value: number;
}
@Component({
  selector: 'app-user-crm',
  templateUrl: './user-crm.component.html',
  styleUrls: ['./user-crm.component.scss']
})
export class UserCrmComponent implements OnInit,OnDestroy{
readonly destroyRef = inject(DestroyRef);
  @ViewChild('dt') dt: Table;
  activeIndex: number = 0;
  activityActiveIndex: number = 0;
  activeItem: any;
  driverNotesHistory: DriverNotesHistory[] = [];
  items;
  truckTypes: VehicleTypeDetail[] = [];
  addButton: boolean = true;
  allDriverVehicle = [];
  vehicleTypeImagePath: string;
  clonedProducts: {} = {};
  formData: FormData = new FormData();
  driverDetails: any
  showInput: boolean = false;
  separateDialCode = false;
  dummy = NO_IMAGE;
  allowedExtensions = ['jpg', 'jpeg', 'png'];
  driverId: string = "";
  dispatherId: string = "";
  credit: number = 0;
  bookingDueCharges: number = 0
  isProfileImgError: boolean = false;
  imageUrl: string;
  NAME_MAX_LENGTH: number = 50;
  paymentList: any[] = [];
  pageNumber: number = 1;
  paymentPageNumber: number = 1;
  bookingList: any[] = [];
  customInvoiceList: any[] = [];
  totalRecords: number;
  totalPaymentRecords: number;
  currentEditingProductId: number | null = null;
  itemsPerPage: number = 10;
  creditItemsPerPage: number = 10;
  pageSize: number = 10;
  years: YearOption[] = [];
  AllUserCredits: any = [];
  totalCreditsRecords: number = 0;
  CreditPageNumber: number = 1;
  currentSkip = 0;
  paymentCurrentSkip: number = 0;
  BookingCurrentSkip: number = 0;
  fromAddVehicle: boolean = false;
  role: string = '';
  roleRoute: string = '';
  compId: string = ''
  cardPaymentList: any;
  bankPaymentList: any;
  paymentMethodSelected: string = '';
  equipmentMsg: string = EQUIPMENT_INFORMATION_LABEL;
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  addSpotMsg: string = ADD_SPOT_LABEL;
  isGroupUser: boolean = false;
  customInvoicePageNumber: number = 1;
  totalCustomInvoices: number;
  reloadSubscription: any;
  filterData:FilterData;
  activeTabIndex:number;
  isResetButton:boolean = false;
  constructor(
    private readonly superAdminService: SuperAdminService,
    private readonly parkingService: ParkingService,
    private readonly toastService: ToastService,
    private readonly route: ActivatedRoute,
    private readonly service: ProfileService,
    private readonly router: Router,
    private readonly companyService: CompanyService,
    public readonly dialogControlService: DialogControlService,
    private readonly driverService: DriverService,
    private readonly sharedDriverService: SharedDriverService,
    private readonly confirmationService: ConfirmationService,
    private readonly reloadService: ReloadService,
    private readonly datePipe:DatePipe,
    private readonly encryptStorage: EncryptionStorageService
  ) { }

  ngOnInit() {
    this.compId = this.encryptStorage.getItem('companyId')
    this.route.queryParams?.subscribe((params) => {
      this.driverId = params['id'] ?? params['Id'];
      this.dispatherId = params['Id'];
      if (!this.dispatherId) {
        this.getVehicleTypeList();
      }

const activeDriverTabIndex = params['paymentInfo'];
      if (activeDriverTabIndex !== undefined) {
        this.activeIndex = +activeDriverTabIndex;
      }
      const { redirectUrl, ...newState } = history.state || {};
      if (redirectUrl) {
        window.open(redirectUrl, '_blank');
        history.replaceState(newState, document.title);
      }
    });
    this.route.queryParamMap.subscribe((params) => {
      this.activeTabIndex = parseInt(params.get('tab'));
      if (this.activeTabIndex !== undefined) {
        this.activityActiveIndex = +this.activeTabIndex;
      }
      const  infoTab= parseInt(params.get('iTab'));
      if (infoTab!== undefined) {
        this.activeIndex = +infoTab;
      }
    });
    this.activitySetActiveTab(this.activityActiveIndex);
    this.setActiveTab(this.activeIndex);
    this.reloadSubscription = this.reloadService.reload$.subscribe(() => {
      this.afterCancelApiCall('BookingTab');
    });
    this.role = this.encryptStorage.getItem('roleName');
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
    this.getDriverNotesHistory(this.driverId);
    this.getUserDetailById();
    this.showInputTrue();
    this.getYearsObj();
    this.fromAddVehicle = false;

    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: 'User Database',
        url: 'super-admin/user-database-list'
      },
      {
        title: this.dispatherId ? 'Group Operator Information' : 'Parker Information',
      },
    ];
    this.companyService.setAdminHeaders('0', breadcrumbObj);
  };

  ngOnDestroy() {
    if (this.reloadSubscription) {
      this.reloadSubscription.unsubscribe();  // Clean up the subscription
    }
  }

  formatDateToString(date : Date) : string {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  showInputTrue() {
    this.superAdminService.showInput$.subscribe(value => {
      this.showInput = value;
    });
  };

  formatStringDate(inputDate: string): string {
    const [datePart, timePart] = inputDate.split(' ');
    const [day, month, year] = datePart.split('.').map(Number);
    const date = new Date(year, month - 1, day, ...timePart.split(':').map(Number));

    const dateOptions: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    };
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false, // Use 24-hour format to avoid AM/PM
    };

    const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
    const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);

    return `${formattedDate} - ${formattedTime}`;
  }

  getYearsObj() {
    const currentYear = new Date().getFullYear();
    for (let year = 2000; year <= currentYear; year++) {
      this.years.push({ key: year, value: year });
    }
  };

  openDeleteModal(id: string): void {
  const isGroupUser = this.dispatherId ? true : false;

  this.superAdminService.checkPendingDuesOrActiveBooking(id).pipe(autoUnsubWith(this.destroyRef)).subscribe({
    next: (response: any) => {
     const hasDuesOrBookings = response?.data?.hasPendingDuesOrActiveBookings;
      const bodyText = hasDuesOrBookings ? response.message : MSG_DELETE_ACCOUNT;

      const dialogData: any = {
        headerText: 'Delete',
        bodyText,
        id,
        isGroupUser,
      };

      if (hasDuesOrBookings) {
        dialogData.isForceFully = true;
      }

      this.dialogControlService.openDialog(DeleteConfirmationModalComponent, {
        width: '23%',
        data: dialogData,
      });
    },
    error: (error) => {
      this.toastService.showToastMessage(
        'error',
        'Error',
        error?.error?.messages
      );
    },
  });
}

  showData(driverId) {
    const actionMap = {
      createBooking: () => {
        this.routeToCreateBooking(driverId);
      },
      deleteAccount: () => {
        this.openDeleteModal(this.driverId);
      },
      Edit: () => {
        this.showInput = true;
        this.activeIndex = 0;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { iTab: 0 },
          queryParamsHandling: 'merge'
        });
      },
      resetPassword: () => {
        this.openResetModal(driverId);
      },
      createInvoice: () => {
        this.encryptStorage.setItem('driverId', driverId);
        const url = `${this.roleRoute}/invoice${this.role === USER_ROLES.SUPER_ADMIN ? `/${this.compId}` : ''}`;
        const navigation: NavigationExtras = {
          state: {
            emailId: this.driverDetails?.email,
          },
        };
        this.router.navigateByUrl(url, navigation);
      },
      openCustomCredits: () => this.openCustomCredits(this.driverDetails),

      convertParkerToGroupOperator: () => {
        this.convertParkerToGroupOperatorModal(this.driverDetails.id);
      }
    }
    this.items = [
      {
        items: [
          {
            label: '',  // This seems to be an empty placeholder
            icon: '',
          },
          {
            label: 'Create Booking',
            icon: 'common-icon custom-createbooking',
            escape: false,
            command: actionMap.createBooking
          },
          ...(this.roleRoute !== 'manager' ? [{
            label: 'Delete Account',
            icon: 'common-icon custom-delete',
            escape: false,
            command: actionMap.deleteAccount
          }] : []),
          {
            label: 'Edit',
            icon: 'common-icon custom-editicon',
            escape: false,
            command: actionMap.Edit
          },
          {
            label: 'Reset Password',
            icon: 'common-icon custom-reset',
            escape: false,
            command: actionMap.resetPassword
          },
          {
            label: 'Create Invoice',  // Another placeholder item
            icon: 'common-icon create-invoice',
            command: actionMap.createInvoice
          },
          {
            label : 'Custom Credit',
            icon: 'common-icon custom-credit',
            escape : false,
            command : actionMap.openCustomCredits
          },
                {
        label: 'Change Role to Group Operator',
        icon: 'common-icon change-role',
        visible: this.driverDetails?.role === 'Driver',
        escape: false,
        command: actionMap.convertParkerToGroupOperator
      }
        ]
      }
    ];
  }

  cancelBookingModal(id: string, total: number, usedCredit: number): void {
    this.dialogControlService.openDialog(CancelBookingComponent, {
      data: {
        id: id,
        total: total,
        usedCredit: usedCredit,
      },
      width: '35%',
    });
  }

  arrivalTimeLessThanTwo(inputDate: number): number {
    let currentDate = new Date();
    const date = new Date(inputDate * 1000);
    const timeDifference = (date.getTime() - currentDate.getTime()) / (1000 * 60 * 60);
    return timeDifference;
  }

  openCustomCredits(userData: any) {
    this.dialogControlService.openDialog(CustomCreditsComponent, {
      styleClass: 'custom-credits-model',
      data: {
        userData: userData,
      },
    });
  }

  showBookingSummary(bookingId: string) {
    this.items = [
      {
        items: [
          {
            label: '',
            icon: '',

},
          {
            label: 'Booking Summary',
            icon: 'pi pi-book',
            escape: false,
            command: () => {
              this.openInvoice(bookingId);
            }
          },
        ]
      },
    ];

  };

  sendInvoiceOnMail(id: string) {

    const request: any = {
      timeZone: Utility.getLocalTimeZone()
    }

    if (this.activityActiveIndex === 2) {
      request.invoiceId = id;
    } else {
      request.bookingId = id;
    }

    this.sharedDriverService.shareInvoice(request).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: () => {
        this.toastService.showToastMessage('success', 'Success', 'Invoice shared successfully')

      }, error: (_error) => {
        this.toastService.showToastMessage('error', 'Error', _error.error?.message);
      }
    })
  }

  viewInvoice(bookingId: string) {

    const req = {
      bookingId: bookingId,
      timeZone: Utility.getLocalTimeZone(),
    }
    this.superAdminService.viewInvoice(req).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response) => {
        window.open(response as string, '_blank')
      }
    })
  }

  navigatetoBookingDeatil(event) {
    const endPointRoute = event?.data ? '/group-booking-details' : '/booking-details';

    const navigation: NavigationExtras = {
      queryParams: {
        id: event.id,
        ...(event.data ? { groupOparatorList: true } : { driverList: true }),
      },
      state: {
        userId: this.driverId
      }
    };

    this.router.navigate([`${this.roleRoute}${endPointRoute}`], navigation);
  }

  onlyNumberInputs(event: KeyboardEvent): void {
    const allowedChars = /[0-9\.]/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  openInvoice(bookinDetail) {
    const component = bookinDetail.userType === USER_TYPE.GROUP_OPERATOR ? GroupBookingInvoiceComponent : BookingInvoiceComponent;
    this.dialogControlService.openDialog(component, {
       width: '65%',
      data: {
        bookingId: bookinDetail?.bookingId,
        updateSlot: false,
      }
    });
  };

  addNotes() {
    this.dialogControlService.openDialog(AddNotesComponent, {
      width: '781px',
      height: '490px',
      data: {
        driverId: this.driverId,
        driverName: this.driverDetails?.name
      }
    });
    this.dialogControlService.onClose().subscribe(() => {

      this.getDriverNotesHistory(this.driverId)
    })
  };

  getDriverNotesHistory(driverId) {

    this.driverService.getDriverNotesHistoryByDriverIdForSuperAdmin(driverId)
      .pipe(autoUnsubWith(this.destroyRef)).subscribe({
        next: (response) => {
          this.driverNotesHistory = response;

        },
        error: () => {
          this.driverNotesHistory = [];

        }
      });
  }

getVehicleTypeList() {
    this.parkingService.getVehicleTypeList().pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (types: VehicleTypeDetail[]) => {
        this.truckTypes = types;

      }
    })
  };
  openResetModal(id: string) {
    this.dialogControlService.openDialog(ResetPasswordConfirmationComponent, {
      width: '23%',
      data: {
        headerText: "Reset",
        bodyText: RESET_PASSWORD_CONFIRMATION,
        id: id
      }
    });

    this.dialogControlService.onClose().subscribe(() => {
      this.getDriverNotesHistory(this.driverId);
    });
  };

openBookingDetail(data) {
    this.dialogControlService.openDialog(VehicleTypeModalComponent, {
      styleClass:'spot-vehicle-model',
      data: {
        truckType: null,
        comingFrom: "DriverInfoSection",
        driverId: this.driverId,
        data: data,
      }
    });
    this.dialogControlService.onClose().subscribe(() => {
      this.getAllVehicleByDriverId(this.driverId);
    })
  }

  getTransactionListForSuperAdmin() {
    const request: any = {
      companyId: [],
      mcNumber: "",
      timeZone: Utility.getLocalTimeZone(),
      pageNumber: this.paymentPageNumber,
      pageSize: this.itemsPerPage,
      driverId: this.driverId,
      bookingType: null,
      transactionType: 0,
      startDateTime: this.filterData?.startdate ? this.formatDateToString(this.filterData?.startdate)  : null,
      endDateTime: this.filterData?.enddate ? this.formatDateToString(this.filterData?.enddate) : null,
      invoiceNumber:this.filterData?.invoiceNumber ? this.filterData?.invoiceNumber : null,
      parkingLotIds:this.filterData?.parkingLot ? this.filterData?.parkingLot : [],
      paymentStatus: this.filterData?.paymentStatus ? this.filterData?.paymentStatus : 0,
    }
    this.superAdminService.getTransactionListForSuperAdmin(request).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (res: any) => {
        if (res?.transactionList && Array.isArray(res.transactionList)) {
          res.transactionList = res.transactionList.map(transaction => {
            if (transaction.paymentStatus === 'Completed') {
              transaction.paymentStatus = 'Paid';
            }
            return transaction;
          });
        }
        this.paymentList = res?.transactionList;
        this.totalPaymentRecords = res?.totalRecords;

      }
    })
  };

  getAllVehicleByDriverId(driverId) {
    this.superAdminService.getAllVehicleByDriverId(driverId).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (_response: any) => {

        this.allDriverVehicle = _response;
      }, error: (error) => {
        if (error.error.message == 'No Vehicle Found. Please try again.') {
          this.allDriverVehicle = [];
        }

      }
    })
  };
  equipmentInfoEdit(event) {
    this.openBookingDetail(event)
  }

  equipmentInfoDelete(event) {
    this.onRowDelete(event.event, event.product)
  }
  onRowEditCancel(product, index: number) {
    this.currentEditingProductId = null;
    this.addButton = true;
    this.allDriverVehicle[index] = this.clonedProducts[product.id];
    delete this.clonedProducts[product.id];
  };

  onRowDelete(event, product) {
    this.currentEditingProductId = null;
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: MSG_DELETE_EQUIPMENT,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const request = {
          id: product.id,
          driverId: this.driverId
        }
        this.superAdminService.deleteDriverVehicleByVehicleId(request).pipe(autoUnsubWith(this.destroyRef)).subscribe({
          next: (_response: any) => {

            this.getAllVehicleByDriverId(this.driverId)
            this.toastService.showToastMessage('success', 'Success', "Equipment information has been deleted successfully.");
          }, error: (error) => {
            this.toastService.showToastMessage('error', 'Error', error.error.message)
          }
        })
      },
    });

  };

  OnChangeVehicleType(event, id): void {
    const selectedTruckType = this.truckTypes.find(type => type.id === event.value);
    if (selectedTruckType) {
      const objectToUpdateIndex = this.allDriverVehicle.findIndex(item => item.id === id);
      if (objectToUpdateIndex !== -1) {
        this.allDriverVehicle[objectToUpdateIndex].vehicleType.vehicleTypeImagePath = selectedTruckType.vehicleTypeImagePath;
      }
    }
  };

  triggerFileInput() {
    const fileInput = document.getElementById('fileInput') as HTMLElement;
    fileInput.click();
  };

  getUserDetailById() {
    this.superAdminService.getUserDetailsById(this.driverId).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response) => {
        this.driverDetails = response;
        if (this.driverDetails.profileImagePath) {
          this.imageUrl = this.driverDetails.profileImagePath;
        }

}
    });
  };
  onInput(product, event: any) {
    product.licenseNumberPlate = event.target.value.toUpperCase();
  }
  receiveDriverBesicData(event) {
    if (event.isGroupUser) {
      this.updateGroupUserProfile(event);
    } else {
      this.updateDriverInformation(event);
    }

}

  callAddNotesFunction(event) {
    if (event.notesData) {
      this.addNotes();
    }
  }
  updateDriverInformation(event: any) {

    const updateRequest = {
      driverId: this.driverId,
      name: event.firstName,
      lastName: event.lastName,
      mobileNumber: event.phone?.number,
      email : event.email,
      profileImagePath: event.profileImagePath,
      countryCode: event.phone?.dialCode,
      iso: event.phone?.countryCode,
      isTermsAndConditionsAccepted: true
    }

    if (event) {
      this.superAdminService.editDriverProfile(updateRequest).pipe(autoUnsubWith(this.destroyRef)).subscribe({
        next: (_response) => {
          this.getUserDetailById();
          this.showInput = false;
          this.superAdminService.setShowInput(false);
          this.toastService.showToastMessage('success', 'Success', 'Profile Updated Successfully');

},
        error: (error) => {
          this.toastService.showToastMessage('error', 'Error', error.error.message);
        }
      });
    } else {

      this.toastService.showToastMessage('error', 'Error', 'Please fill required fields.')
    }

  };

  

  onPageChange(event: any) {
    this.BookingCurrentSkip = event.first;
    this.pageNumber = event.page + 1;
    this.getBookingList();
    CommonFunctions.scrollTopRow('booking');
  }

  afterCancelApiCall(tab: string) {
    if (tab === 'BookingTab') {
      this.getBookingList();
    } else if (tab === 'InvoiceTab') {
      this.getParkingLotInvoiceForDriver();
    }

  }
  afterMarkAsPaidOrCancel() {
    this.getUserDetailById();
  }

  creditOnPageChange(event: any) {
    this.currentSkip = event.first;
    this.CreditPageNumber = event.page + 1;
    CommonFunctions.scrollTopRow('credits');
    this.GetAllUserCreditsByDriverId();
  };
  onPagePaymentList(event: any) {
    this.paymentCurrentSkip = event.first
    this.paymentPageNumber = event.page + 1;
    CommonFunctions.scrollTopRow('payment');
    this.getTransactionListForSuperAdmin();
  }

  onPageCustomInvoiceList(event: any) {
    this.customInvoicePageNumber = event.page + 1;
    CommonFunctions.scrollTopRow('custom');
    this.getParkingLotInvoiceForDriver();
  }

getBookingList() {
    const request: any = {
      startDate: this.filterData?.startdate ? this.formatDateToString(this.filterData?.startdate) : null,
      endDate: this.filterData?.enddate ?this.formatDateToString(this.filterData?.enddate) : null,
      invoiceNumber:this.filterData?.invoiceNumber ? this.filterData?.invoiceNumber : null,
      parkingLotIds:this.filterData?.parkingLot ? this.filterData?.parkingLot : [],
      paymentStatus: this.filterData?.paymentStatus ? this.filterData?.paymentStatus : 0,

      companyId: null,
      search: "",
      status: BookingType.All,
      pageSize: this.itemsPerPage,
      pageNumber: this.pageNumber,
      driverGroupId: this.driverId,
      bookingType: this.activityActiveIndex === 0 ? 0: 2,
      userType: this.dispatherId ? 4 : this.driverId ? 0 : null,// UserType 0 driver, GO 4
      timeZone: Utility.getLocalTimeZone()
    }
    this.superAdminService.getAllBookingsList(request).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (res: any) => {
    this.bookingList =  res.data.bookingList?.length ? res.data.bookingList?.map((booking: any) => {
          if (booking.paymentInfo?.bookingStatus.label === "Payment link shared") {
            booking.paymentInfo.bookingStatus.label = "Pending";
          }
          return {
            ...booking,
            leaf: !booking.isChildExist,
            children: []
          };
        }) : [];
        this.totalRecords = res.data.totalRecords;

      }
    })
  };

  getUserCredit() {
    this.service.getUserCredit().pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: ((res: any) => {
        this.credit = res.credit
        this.bookingDueCharges = res.bookingDueCharges
      }),
      error: ((error) => {
        this.toastService.showToastMessage('error', 'Error', error.error.message)
      })
    })
  };

  setActiveTab(index: number) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { iTab: index | 0 },
      queryParamsHandling: 'merge' // Preserve other query parameters
    });
    if(index === 1) {
      if(this.driverId){
        this.getAllVehicleByDriverId(this.driverId);
      }
    }
  };

  activitySetActiveTab(index: number) {
    this.activityActiveIndex = index;

    // Update the URL with the active tab index
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: index },
      queryParamsHandling: 'merge' // Preserve other query parameters
    });

    if (index === 1) {
      this.CreditPageNumber = 1;
      this.BookingCurrentSkip = 1;
      this.currentSkip = 1;
      this.pageNumber = 1;
      this.getTransactionListForSuperAdmin();
    } else if (index === 2) {
      this.customInvoicePageNumber = 1;
      this.getParkingLotInvoiceForDriver();

    } else if (index === 0 || index === 3) {
      this.CreditPageNumber = 1;
      this.currentSkip = 1;
      this.paymentPageNumber = 1;
      this.BookingCurrentSkip = 1;
      this.pageNumber = 1;
      this.getBookingList();
    }
  }

  routeToCreateBooking(userId: any): void {
    const url = this.dispatherId ? `${this.roleRoute}/create-group-operator-booking` : `${this.roleRoute}/create-booking`;
    const navigationExtras: NavigationExtras = {
      state: {
        userId: userId
      }
    };
    this.router.navigateByUrl(url, navigationExtras);
  };

  generateUniqueId(length: number = 9): string {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => (byte % 36).toString(36)).join('');
  }

  getParkingLotInvoiceForDriver() {

    const req = {
      name: '',
      phoneNumber: '',
      parkingLotName: '',
      pageNumber: this.customInvoicePageNumber,
      pageSize: this.itemsPerPage,
      userId: this.driverId,
      timeZone: Utility.getLocalTimeZone(),
      startDate: this.filterData?.startdate ? this.filterData?.startdate : null,
      endDate: this.filterData?.enddate ? this.filterData?.enddate : null,
      invoiceNumber:this.filterData?.invoiceNumber ? this.filterData?.invoiceNumber : null,
      parkingLotIds:this.filterData?.parkingLot ? this.filterData?.parkingLot : [],
      paymentStatus: this.customInvoicePaymentStatus()
    }
    this.sharedDriverService
      .getParkingLotInvoiceForDriver(req)
      .pipe(autoUnsubWith(this.destroyRef)).subscribe({
        next: (response) => {
          this.customInvoiceList = response.data as any[];
          this.totalCustomInvoices = response.totalRecords

        },
        error: (_error) => {
          this.customInvoiceList = [];
        },
      });
  }
  downloadInvoice(id) {

    const req = {
      InvoiceType: InvoiceType.OneTimeInvoice,
      id: id
    };
    this.sharedDriverService.downloadInvoice(req).pipe(
      autoUnsubWith(this.destroyRef)).subscribe({
      next: (_response) => {
        const url = _response.data as string;
        window.open(url, "_blank");
      },
      error: (er: Error) => {
        this.toastService.showToastMessage('error', 'Error', er.message);
      }
    });
  }
  GetAllUserCreditsByDriverId() {

    let data = {
      driverId: this.driverId,
      pageNumber: this.CreditPageNumber,
      pageSize: this.creditItemsPerPage
    }

    this.superAdminService.GetAllUserCreditsByDriverId(data).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response) => {
        this.AllUserCredits = response.data;
        this.totalCreditsRecords = response?.totalRecords;

      }, error: (error) => {
        if (error) {
          this.AllUserCredits = [];
          this.totalCreditsRecords = 0;
          this.CreditPageNumber = 1;
          this.currentSkip = 1;

        }
      }
    })
  }

  backRoute() {
    const url = this.driverService.getPreviousUrl();
    if (url) {
      const [path, queryString] = url.split('?');
      const queryParams: { [key: string]: string } = {};
      if (queryString) {
        const params = new URLSearchParams(queryString);
        params.forEach((value, key) => {
          queryParams[key] = value;
        });
      }
      this.router.navigate([path], { queryParams });
    } else {
      this.router.navigate([`${this.roleRoute}/user-database-list`]);
    }
    this.showInput = false;
    this.superAdminService.setShowInput(false);
  }
  updateGroupUserProfile(event) {
    let data = {
      id: this.dispatherId,
      profileImagePath: event.profileImagePath,
      firstName: event.firstName,
      lastName: event.lastName,
      mobileNumber: event.phone?.number,
      dotNumber: event.dotNumber,
      email: event.email,
      groupName: event.groupName,
      companyName: event.companyName,
      address: event.address,
      zipCode: event.zipCode,
      city: event.city,
      country: event.country,
      aboutGroup: event.aboutGroup,
      countryCode: event.phone?.dialCode,
      iso: event.phone?.countryCode
    }

    this.superAdminService.updateGroupUserProfile(data).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (_response) => {
        this.getUserDetailById();
        this.showInput = false;
        this.superAdminService.setShowInput(false);
        this.toastService.showToastMessage('success', 'Success', 'Profile Updated Successfully');
      }, error: (error) => {
        this.toastService.showToastMessage('error', 'Error', error.error.message);
      }
    })
  }

  applyFliter(){
    this.dialogControlService.openDialog(UserCrmFilterModalComponent, {
      styleClass: 'apply-filter-model',
      data:{
        companyId:this.compId,
        filterData:this.filterData
      },
    });
    this.dialogControlService.onClose().pipe(autoUnsubWith(this.destroyRef)).subscribe((data) => {
      if (data) {
        this.filterData = data.filterData;
            this.isResetButton = data.isResetButton;
        if(this.filterData){
          this.activitySetActiveTab(this.activeTabIndex);
        }
      }
    });
  }

  customInvoicePaymentStatus(): number {
    if (this.filterData) {
      switch (this.filterData.paymentStatus) {
        case 2:
          return 1;
        case 1:
          return 0;
        case 4:
          return 3;
        case 9:
          return 4;
        case 5:
          return 2
      }

    }
    return null
  }

  resetFilter(){
    this.isResetButton = false;
    this.filterData = {
      startdate: null,
      enddate: null,
      parkingLot: [],
      invoiceNumber: null,
      paymentStatus: 0
    }
    this.activitySetActiveTab(this.activityActiveIndex);
  }
    convertParkerToGroupOperatorModal(userId: string) {
    this.dialogControlService.openDialog(UserConvertToGroupOperatorModalComponent, {
       styleClass: 'convert-parker-model',
      data: {
        userId: userId,
        email: null,
    },
    });
  }
}

